import queryString from 'query-string';
import { CREATE, DELETE, GET_LIST, UPDATE, GET_DETAIL } from '../../api/masterData/projectTag';

const state = {
	list: [],
	detail: null,
};

const mutations = {
	SET_LIST: (states, payload) => {
		states.list = payload;
	},
	SET_DETAIL: (states, payload) => {
		states.detail = payload;
	},
};

const actions = {
	GET_LIST: async ({ commit }, query) => {
		query = queryString.stringify(query);
		const resp = await GET_LIST(query);
		const data = resp.data.data;
		commit('SET_LIST', data);
	},
	GET_DETAIL: async ({ commit }, id) => {
		const resp = await GET_DETAIL(id);
		const data = resp.data.data;
		commit('SET_DETAIL', data);
	},
	CREATE: async ({ commit }, payload) => {
		const resp = await CREATE(payload);
		return resp;
	},
	UPDATE: async ({ commit }, payload) => {
		const resp = await UPDATE(payload.id, payload);
		return resp;
	},
	DELETE: async ({ commit }, id) => {
		const resp = await DELETE(id);
		return resp;
	},
};

const getters = {
	list: (states) => states.list,
	detail: (states) => states.detail,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
